export default "__VITE_ASSET__c07a56cb__"